export const BOOK_STUDENT_CLASS_BANNER = 'classBannerBooking/BOOK_STUDENT_CLASS_BANNER'
export const SUBMIT_CLASS_REVIEW = 'classBannerBooking/SUBMIT_CLASS_REVIEW'
export const CHANGE_BOOKING_STATUS = 'classBannerBooking/CHANGE_BOOKING_STATUS'
export const RESET_BOOK_STUDENT_CLASS_BANNER_ERROR =
  'classBannerBooking/RESET_BOOK_STUDENT_CLASS_BANNER_ERROR'
export const RESET_CHANGE_BOOKING_STATUS_ERROR =
  'classBannerBooking/RESET_CHANGE_BOOKING_STATUS_ERROR'
